<template>
    <form class="row justify-content-center" target="_blank" :action="public_url + '/student-requests/confirm-reservation'">
        <div v-html="formInputs"></div>
        <input v-if="invoice" type="hidden" name="invoice" value="1">
        <input v-if="whatsapp" type="hidden" name="WASendOffer" value="1">
        <div class="col-xl-4 col-md-6">
            <div class="card course-calculator-card px-3 py-3 mt-4">
                <div class="d-flex align-items-center calc-btn-group">
                    <i class="fas fa-file-invoice"></i>
                    <button @click="invoice = true, whatsapp = false" class="btn">{{ tra.get_price_quote_btn }}</button>
                </div>
            </div>
        </div>
        <div class="col-xl-4 col-md-6">
            <div class="card course-calculator-card px-3 py-3 mt-4">
                <div class="d-flex align-items-center calc-btn-group">
                    <i class="fab fa-whatsapp"></i>
                    <button @click="whatsapp = true, invoice = true" class="btn">{{ tra.send_price_whatsapp }}</button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>

export default {
    props: ['formInputs', 'base_url', 'tra'],
    data() {
        return {
            invoice: false,
            whatsapp: false,
            public_url: window.public_url
        };
    },

    computed: {

    },

    watch: {

    },

    methods: {

    },
    mounted() {
    },
};
</script>


<style scoped>
.calc-btn-group .btn {
    background-color: transparent;
    border: none;
    color: #009994;
    font-size: 17px;
    font-weight: 700;
}

.calc-btn-group i {
    font-size: 20px;
    background-color: #009994;
    color: #fff;
    padding: 5px 10px;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>